// tslint:disable-next-line:missing-jsdoc
import merge from 'deepmerge';
import { ENV as DEFAULT_ENV } from './config.default';
import { CMNFNC_BASE_API_ENDPOINT, AUTH_ENDPOINT } from '../environment';

export const ENV = merge(DEFAULT_ENV, {
  PRODUCTION: false,
  AUTH: {
    SP_LOGIN_URL: AUTH_ENDPOINT + '/landing/login?redirectUrl=',
    SP_LOGOUT_URL: AUTH_ENDPOINT + '/landing/logout?redirectUrl=',
    AUTH_USER: CMNFNC_BASE_API_ENDPOINT + '/authorizationuserblnginfo/',
    AUTH_ACTION: CMNFNC_BASE_API_ENDPOINT + '/authorizationaction/',
    AUTH_MENU: CMNFNC_BASE_API_ENDPOINT + '/authorizationmenu/',
    DEV_LOGIN: AUTH_ENDPOINT + '/devLogin/login',
    JWT_RENEW: AUTH_ENDPOINT + '/devLogin/jwtRenew'
  },
  i18n: {
    translate: {
      directories: [
        './assets/i18n/'
      ]
    }
  }
});



// WEBPACK FOOTER //
// ./src/config/config.dev.ts